'use client'
import { useEffect, useState } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { useSession } from 'next-auth/react'

import { extractTokenFromClientSession } from 'modules/customer'
import { Promotion } from 'modules/products'
import { SeoListName } from 'shared/analytics'
import { createAsPath } from 'shared/utils/searchParams'

import { getPromotionInformation } from '../../../api'
import { PromotionInformation } from '../../../types'

import SpecialPromotionDescription from './SpecialPromotionDescription'
import SpecialPromotionItems from './SpecialPromotionItems'
import SpecialPromotionRewardItem from './SpecialPromotionRewardItem'

const SPECIAL_PROMOTION_ITEMS_LIST_NAME =
  SeoListName.SPECIAL_PROMOTION_ITEMS_LIST_NAME

const SpecialPromotionContent = ({ promotion }: { promotion: Promotion }) => {
  const session = useSession()
  const token = extractTokenFromClientSession(session)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const asPath = createAsPath(
    pathname || '',
    searchParams || new URLSearchParams()
  )

  const [promotionInformation, setPromotionInformation] =
    useState<PromotionInformation>({
      conditionDescription: '',
      targetDescription: '',
      targetProduct: null,
      targetProductGroup: null,
      promotionCategory: null,
      promotionBrand: null,
      promotionGroup: null
    })

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true)
      const promoInfo = await getPromotionInformation(promotion, token)

      setPromotionInformation(() => promoInfo)
      setLoading(false)
    }

    void fetchProduct()
  }, [])

  return (
    <>
      <SpecialPromotionDescription
        promotion={promotion}
        promotionInformation={promotionInformation}
        loading={loading}
      />

      <SpecialPromotionItems
        promotion={promotion}
        listName={SPECIAL_PROMOTION_ITEMS_LIST_NAME}
        seoButtonPlace={asPath}
        products={
          promotionInformation.promotionCategory ||
          promotionInformation.promotionBrand ||
          promotionInformation.promotionGroup
        }
      />

      {(promotionInformation.targetProduct ||
        promotionInformation.targetProductGroup) && (
        <SpecialPromotionRewardItem
          product={promotionInformation.targetProduct}
          productGroup={promotionInformation.targetProductGroup}
          seoButtonPlace={asPath}
        />
      )}
    </>
  )
}

export default SpecialPromotionContent
